import React from "react";

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("[ErrorBoundary]", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          className="min-h-[60vh] flex items-center justify-center px-4"
          data-testid="error-boundary-fallback"
        >
          <div className="max-w-sm w-full text-center">
            <div className="w-14 h-14 rounded-full bg-red-50 flex items-center justify-center mx-auto mb-4">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-7 w-7 text-red-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </div>
            <h2 className="font-heading text-xl text-navy mb-2">Something went wrong</h2>
            <p className="text-gray-500 text-sm mb-6 leading-relaxed">
              This section encountered an error. The rest of the app should still work.
            </p>
            <div className="flex flex-col gap-2">
              <button
                onClick={() => window.location.reload()}
                className="px-5 py-2 bg-navy text-white rounded-full text-sm font-medium hover:bg-navy/90 transition-colors"
                data-testid="error-boundary-refresh"
              >
                Refresh Page
              </button>
              <a
                href="/request-page"
                className="text-xs text-gray-400 hover:text-gold transition-colors"
                data-testid="error-boundary-report"
              >
                Report an issue
              </a>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
